import { createContext } from 'react';
const FocusContext = createContext();
export default FocusContext;
